// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Pages
import LandingPage from './pages/LandingPage';
import TermsAndPrivacy from './components/TermsAndPrivacy';
import Signup from './pages/Signup';
import Payment from './components/Payment';
import GoogleAuth from './firebase_func/GoogleAuth';
import Login from './pages/Login';
import Login2 from './pages/Login2';
import NotebookHome from './pages/NotebookHome';
import Wiki from './pages/Wiki';
import Calendar from './pages/Calendar';
import SuccessCoach from './pages/SuccessCoach';
import Roadmap from './pages/Roadmap';
import Workspace from './components/Workspace';
import Settings from './pages/Settings';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/terms-and-privacy" element={<TermsAndPrivacy />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/google-auth" element={<GoogleAuth />} />
        <Route path="/login" element={<Login />} />
        <Route path="/login2" element={<Login2 />} />
        <Route path="/notebookhome" element={<NotebookHome />} />
        <Route path="/notebookhome/wiki" element={<Wiki />} />
        <Route path="/notebookhome/calendar" element={<Calendar />} />
        <Route path="/notebookhome/success-coach" element={<SuccessCoach />} />
        <Route path="/notebookhome/roadmap" element={<Roadmap />} />
        <Route path="/notebookhome/workspace" element={<Workspace />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Router>
  );
}

export default App;
